import gql from 'graphql-tag';

export const AUTHENTICATED_QUERY = gql`
  query authenticatedQuery {
    authenticated @client
  }
`;
